export type TokenizedString = TokenizedChar[];

export function tokenizeString(text: string, mask: string) {
    const maskTokens = tokenizeMask(mask);
    const stringStack = Array.from(text);
    const maskWithValues = maskTokens.reduceRight((tokenizedString: TokenizedString, token: Token) => {
        switch (token) {
            case "alphanumeric":
            case "secret":
                const char = stringStack.length ? stringStack.pop() : "";
                tokenizedString.unshift({
                    token,
                    value: char
                });
                break;
            case "separator":
                // The separator has no value.
                tokenizedString.unshift({
                    token,
                    value: ""
                });
                break;
        }
        return tokenizedString;
    }, []);
    // If the string exceeds the format of the mask, display any remaining characters in the string.
    const rest: TokenizedString = stringStack.map<TokenizedChar>(c => ({
        token: "alphanumeric",
        value: c
    }))
    return rest.concat(maskWithValues);
}

function tokenizeMask(mask: string): Token[] {
    return Array.from(mask).reduceRight((tokens: Token[], char) => {
        let token: Token;
        switch (char) {
            case "*":
                token = "secret";
                break;
            case "-":
                token = "separator";
                break;
            default:
                token = "alphanumeric";
                break;
        }
        tokens.unshift(token);
        return tokens;
    }, []);
}

/**
 * Convert the given mask into a mask that encodes whether the character will be displayed as secret
 * depending on the reveal function.
 * @param mask The original mask to be converted to a mask where secret characters are tokenized into placeholders.
 * @param reveal A function describing whether a character in the mask will be revealed.
 * @example revealMaskAsString("000-00-0000", (text, i, c) => i > 4) => "***-**-0000" // Hide characters 0 to 4, excluding separators.
 */
export function revealMaskAsString(mask: string, reveal: (text: string, i: number, c: string) => boolean) {
    let i = 0;
    const result = [];
    for (const c of mask) {
        if (c === "-") {
            result.push(c)
        } else if (c === "*" || !reveal(mask, i, c)) {
            // Asterisks contribute to the index passed to the reveal function.
            result.push("*");
            i++;
        } else {
            // Character is revealed. Also contributes the index passed to the reveal function.
            result.push(c);
            i++;
        }

    }
}

type Token = "secret" | "separator" | "alphanumeric";

interface TokenizedChar {
    token: "secret" | "separator" | "alphanumeric";
    value: string;
}
